// function resolveBaseUrl() {
//   const envUrl = (process.env.REACT_APP_O2C_API_URL || process.env.REACT_APP_ORDER_FULFILLMENT_API_URL || '').trim();
//   if (envUrl) {
//     return envUrl.replace(/\/$/, '');
//   }
//   return 'https://dev-agent.savictech.com/o2c';
// }

// const BASE_URL = resolveBaseUrl();

// async function apiFetch(path, options = {}) {
//   try {
//     return await fetch(`${BASE_URL}${path}`, options);
//   } catch (_err) {
//     throw new Error(
//       `Cannot connect to O2C backend at ${BASE_URL}. ` +
//       'Set REACT_APP_O2C_API_URL if needed.'
//     );
//   }
// }

// async function handleResponse(res) {
//   if (!res.ok) {
//     let detail = `HTTP ${res.status}`;

//     try {
//       const data = await res.json();
//       if (Array.isArray(data?.detail)) {
//         detail = data.detail
//           .map((e) => `[${Array.isArray(e.loc) ? e.loc.join(' -> ') : e.loc}] ${e.msg}`)
//           .join(' | ');
//       } else if (typeof data?.detail === 'string') {
//         detail = data.detail;
//       } else {
//         detail = JSON.stringify(data);
//       }
//     } catch (_) {}

//     throw new Error(detail);
//   }

//   return res.json();
// }

// export const ingestPurchaseOrder = (file) => {
//   const formData = new FormData();
//   formData.append('file', file);
//   return apiFetch('/ingest-po', {
//     method: 'POST',
//     body: formData,
//   }).then(handleResponse);
// };

// export const confirmIngestedPurchaseOrder = (payload) =>
//   apiFetch('/ingest-po/confirm', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify(payload),
//   }).then(handleResponse);

// export const getOrders = () =>
//   apiFetch('/orders').then(handleResponse);

// export const getOrderDetail = (orderId) =>
//   apiFetch(`/orders/${encodeURIComponent(orderId)}/detail`).then(handleResponse);

// export const processOrder = (orderId) =>
//   apiFetch(`/orders/${encodeURIComponent(orderId)}/process`, {
//     method: 'POST',
//   }).then(handleResponse);

// export const approveOrder = (orderId, decision = 'approve') =>
//   apiFetch(`/orders/${encodeURIComponent(orderId)}/approve`, {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ decision }),
//   }).then(handleResponse);

// export { BASE_URL as O2C_API_BASE_URL };



function resolveBaseUrl() {
  const envUrl = (process.env.REACT_APP_O2C_API_URL || process.env.REACT_APP_ORDER_FULFILLMENT_API_URL || '').trim();
  if (envUrl) {
    return envUrl.replace(/\/$/, '');
  }
  return 'https://dev-agent.savictech.com/o2c';
}

const BASE_URL = resolveBaseUrl();
const ROOT_URL = BASE_URL.replace(/\/o2c$/, '') || 'https://dev-agent.savictech.com';

// ── Token / session helpers ──────────────────────────────────────────────────
const TOKEN_KEY = 'o2c_token';
const USER_KEY  = 'o2c_user';

export function getToken()       { return localStorage.getItem(TOKEN_KEY) || ''; }
export function getCurrentUser() {
  try { return JSON.parse(localStorage.getItem(USER_KEY) || 'null'); }
  catch { return null; }
}
export function setAuthData(token, userData) {
  localStorage.setItem(TOKEN_KEY, token);
  if (userData) localStorage.setItem(USER_KEY, JSON.stringify(userData));
}
export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

// ── Role gates ───────────────────────────────────────────────────────────────
export function canUpload()         { return getCurrentUser()?.role === 'order_manager'; }
export function canCreditApprove()  { return getCurrentUser()?.role === 'credit_approver'; }
export function canPricingApprove() { return getCurrentUser()?.role === 'pricing_approver'; }
export function canApproveAny()     {
  const r = getCurrentUser()?.role;
  return r === 'credit_approver' || r === 'pricing_approver';
}

// ── Auth endpoint ────────────────────────────────────────────────────────────
export async function login(username, password) {
  const res = await fetch(`${ROOT_URL}/auth/token`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail || 'Invalid username or password.');
  }
  return res.json();
}

async function apiFetch(path, options = {}) {
  const token = getToken();
  const authHeader = token ? { Authorization: `Bearer ${token}` } : {};
  const merged = { ...options, headers: { ...authHeader, ...options.headers } };
  try {
    const res = await fetch(`${BASE_URL}${path}`, merged);
    if (res.status === 401) {
      clearAuth();
      window.dispatchEvent(new Event('o2c:logout'));
      throw new Error('Session expired. Please log in again.');
    }
    return res;
  } catch (err) {
    if (err.message === 'Session expired. Please log in again.') throw err;
    throw new Error(
      `Cannot connect to O2C backend at ${BASE_URL}. ` +
      'Set REACT_APP_O2C_API_URL if needed.'
    );
  }
}

async function handleResponse(res) {
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;

    try {
      const data = await res.json();
      if (Array.isArray(data?.detail)) {
        detail = data.detail
          .map((e) => `[${Array.isArray(e.loc) ? e.loc.join(' -> ') : e.loc}] ${e.msg}`)
          .join(' | ');
      } else if (typeof data?.detail === 'string') {
        detail = data.detail;
      } else {
        detail = JSON.stringify(data);
      }
    } catch (_) {}

    throw new Error(detail);
  }

  return res.json();
}

export const ingestPurchaseOrder = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return apiFetch('/ingest-po/extract', {
    method: 'POST',
    body: formData,
  }).then(handleResponse);
};

export const confirmIngestedPurchaseOrder = (payload) =>
  apiFetch('/ingest-po/confirm', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).then(handleResponse);

export const getOrders = () =>
  apiFetch('/orders').then(handleResponse);

export const getOrderDetail = (orderId) =>
  apiFetch(`/orders/${encodeURIComponent(orderId)}/detail`).then(handleResponse);

export const processOrder = (orderId) =>
  apiFetch(`/orders/${encodeURIComponent(orderId)}/process`, {
    method: 'POST',
  }).then(handleResponse);

export const approveOrder = (orderId, decision = 'approve') =>
  apiFetch(`/orders/${encodeURIComponent(orderId)}/approve`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ decision }),
  }).then(handleResponse);

export { BASE_URL as O2C_API_BASE_URL };
